import { Injectable } from '@angular/core';
declare var dataLayer: any;

@Injectable({
  providedIn: 'root'
})
export class DataLayersService {

  constructor() { }

  // Tracks offers already fired in the current home visit; cleared on HomeComponent destroy
  private _viewedCardIds = new Set<string>();

  clearViewedCardOffers(): void {
    this._viewedCardIds.clear();
  }

  // ── Helpers ───────────────────────────────────────────────────────────────

  /** Deriva offer_is_featured a partir del labelType del backend */
  static getOfferIsFeatured(labelType: string): 'yes' | 'no' {
    return labelType === '1' ? 'yes' : 'no';
  }

  static getOfferLabel(labelType: string, textLabel: string = ''): string {
    if (textLabel && textLabel.trim()) {
      return textLabel.trim();
    }
    switch (labelType) {
      case '1': return 'Oferta Destacada';
      case '2': return 'Oferta Nueva';
      default:  return 'normal';
    }
  }

  // ── Eventos GA4 existentes ────────────────────────────────────────────────

  // GTM conserva el modelo de dataLayer entre pushes: sin este reset, campos de
  // eventos de oferta (content_type, button_name, etc.) quedan pegados en el siguiente evento genérico.
  private readonly _offerEventKeysReset = {
    content_type: undefined,
    content_id: undefined,
    brand_offer: undefined,
    offer_is_featured: undefined,
    offer_label: undefined,
    button_name: undefined,
  };

  dl_userId(
    id_usuario: string | null,
    tipo_usuario: string,
    user_data?: { document_type?: string; document_number?: string; email?: string; phone_number?: string } | null
  ) {
    const payload: any = {
      ...this._offerEventKeysReset,
      'event': 'ga_event',
      'name_event': 'user',
      'user_id': id_usuario,
      'user_tye': tipo_usuario
    };
    if (user_data) {
      payload['user_data'] = user_data;
    }
    dataLayer.push(payload);
  }
  /**
   * EVENTO GA4 - Parámetro: menu_option
   */
  dl_eventoGA4_menu( name_event: string, texto: string ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event': name_event,
      'menu_option': texto,
    });
  }
  /**
   * EVENTO GA4 de 1 parámetro
   * @param name_event: Nombre de evento.
   */
  dl_eventoGA4_general( name_event:string ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event' : name_event
    });
  }
  /**
   * EVENTO GA4 - search
   */
  dl_eventoGA4_search( busqueda: string, tipo_credito: string | null, digital: boolean | null, monto: string | null, termino: string | null, tipo_lugar: string | null ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event' : 'search',
      'search_term': busqueda,
      'filter_typecredit': tipo_credito,
      'filter_digital': digital,
      'filter_amount': monto,
      'filter_term': termino,
      'filter_typeplace': tipo_lugar
    });
  }

  /** select_content | continue_application | send_feedback */
  dl_eventoGA4_content(
    nombre_evento: string,
    tipo_producto: string,
    id_oferta: string,
    marca: string,
    is_featured: 'yes' | 'no' = 'no',
    label_oferta: string = 'normal'
  ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event' : nombre_evento,
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca,
      'offer_is_featured': is_featured,
      'offer_label': label_oferta
    });
  }
  /**
   * EVENTO GA4 - confirm_application
   */
    dl_eventoGA4_confirm_application(
    tipo_producto: string | null,
    id_oferta: string | null,
    marca: string | null,
    texto: string,
    is_featured: 'yes' | 'no' = 'no',
    label_oferta: string = 'normal'
  ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event' : 'confirm_application',
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca,
      'offer_is_featured': is_featured,
      'offer_label': label_oferta,
      'button_name': texto
    });
  }

  dl_eventoGA4_view_blog(name_event:string,blog_name:string,date : string){
    dataLayer.push({
      'event': 'ga_event',
      'name_event' : name_event,
      'blog_name': blog_name,
      'date': date,
    });
  }

  dl_eventoGA4_event_button(name_event:string, button_name:string){
    dataLayer.push({
      'event': 'ga_event',
      'name_event' : name_event,
      'button_name': button_name
    });
  }

  /** view_offer al entrar al detalle de oferta */
  dl_eventoGA4_view_offer(
    tipo_producto: string,
    id_oferta: string,
    marca: string,
    is_featured: 'yes' | 'no',
    label_oferta: string
  ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event' : 'view_offer',
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca,
      'offer_is_featured': is_featured,
      'offer_label': label_oferta
    });
  }

  dl_eventoGA4_offer_return(credit_name:string, button_name:string){
    (window as any).dataLayer.push({
      'event': 'ga_event',
      'name_event' : 'clic_regresar',
      'credit_name': credit_name,
      'button_name': button_name
    });
  }

  // ── Nuevos eventos GA4 Bancolombia ────────────────────────────────────────

  /** cancel_application: cancelar/cerrar modal de aplicación */
  dl_eventoGA4_cancel_application(
    tipo_producto: string | null,
    id_oferta: string | null,
    marca: string | null,
    is_featured: 'yes' | 'no',
    label_oferta: string,
    texto: string
  ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event': 'cancel_application',
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca,
      'offer_is_featured': is_featured,
      'offer_label': label_oferta,
      'button_name': texto
    });
  }

  /** modal_application: se muestra el modal de aplicación */
  dl_eventoGA4_modal_application(
    tipo_producto: string,
    id_oferta: string,
    marca: string,
    is_featured: 'yes' | 'no',
    label_oferta: string
  ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event': 'modal_application',
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca,
      'offer_is_featured': is_featured,
      'offer_label': label_oferta
    });
  }

  /** view_card_offer: tarjeta Bancolombia visualizada */
  dl_eventoGA4_view_card(
    tipo_producto: string,
    id_oferta: string,
    marca: string,
    is_featured: 'yes' | 'no',
    label_oferta: string
  ){
    // Two CardComponent instances exist simultaneously (desktop + mobile carousel)
    if (this._viewedCardIds.has(id_oferta)) { return; }
    this._viewedCardIds.add(id_oferta);
    dataLayer.push({
      'event': 'ga_event',
      'name_event': 'view_card_offer',
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca,
      'offer_is_featured': is_featured,
      'offer_label': label_oferta
    });
  }

  /**
   * application_step_view | application_step_submit
   * customData permite agregar term, plan_name, payment_day según el paso.
   */
  dl_eventoGA4_application_process(
    nombre_evento: string,
    nombre_flujo: string,
    nombre_paso: string,
    numero_paso: number,
    tipo_producto: string,
    id_oferta: string,
    marca: string,
    customData: Record<string, any> | null = null
  ){
    const eventData: Record<string, any> = {
      'event': 'ga_event',
      'name_event': nombre_evento,
      'flow_name': nombre_flujo,
      'step_name': nombre_paso,
      'step_number': numero_paso,
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca
    };
    dataLayer.push({ ...eventData, ...(customData ?? {}) });
  }

  /**
   * Estados del proceso Bancolombia:
   * credit_pre_approved | credit_in_process | credit_disbursement |
   * credit_after_hours  | application_process_error
   */
  dl_eventoGA4_application_status(
    nombre_evento: string,
    nombre_flujo: string,
    tipo_producto: string,
    id_oferta: string,
    marca: string,
    term: string = '',
    plan_name: string = ''
  ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event': nombre_evento,
      'flow_name': nombre_flujo,
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca,
      'term': term,
      'plan_name': plan_name
    });
  }

  /** partner_modal_sso: se muestra el modal SSO de Bancolombia */
  dl_eventoGA4_partner_modal_sso(
    tipo_producto: string,
    id_oferta: string,
    marca: string
  ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event': 'partner_modal_sso',
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca
    });
  }

  /** partner_modal_otp: se muestra el OTP/firma de Bancolombia */
  dl_eventoGA4_partner_modal_otp(
    nombre_flujo: string,
    tipo_producto: string,
    id_oferta: string,
    marca: string,
    term: string = '',
    plan_name: string = ''
  ){
    dataLayer.push({
      'event': 'ga_event',
      'name_event': 'partner_modal_otp',
      'flow_name': nombre_flujo,
      'content_type': tipo_producto,
      'content_id': id_oferta,
      'brand_offer': marca,
      'term': term,
      'plan_name': plan_name
    });
  }

   /** Funcion para enviar eventos dinamicos como parametro */
  dl_event(event:object){
    dataLayer.push(event);
  }
}
